import { UserAlertSubscription } from '@intelligent-play-v2/domain';
import { queryBuilder } from '../queryBuilder';

export const getUserAlertSubscriptions = async (): Promise<
  UserAlertSubscription[]
> => {
  const { data } = await queryBuilder('GET', 'alerts/userAlertSubscriptions');
  return data;
};
